export interface IVideoProps {
	provider: EProviders;
	videoId: string;
	mobileVideoId?: string;
	videoConfig: IVideoConfig
	showPlayButton?: boolean;
	showMuteButton?: boolean;
	controlsConfig?: TControlsConfig;
	changeBreakpoint?: 'extra-small' |'small' | 'medium' | 'large' | 'x-large' | 'xx-large' | 'xxx-large' | 'xxxx-large';
	aspectRatio?: string;
	aspectRatioMobile?: string;
	thumbnail?: string;
	thumbnailMobile?: string;
	/**
	 * Below the fold of a CMS module: the aspect ratio of the provider does not hold the server response, the video is
	 * streamed after it when the provider is slow (PLAN.md 2b.7c). Default `false`: critical, as the PDP gallery,
	 * whose first slide may be a video (LCP).
	 */
	nonCritical?: boolean;
}

interface IVideoConfig {
	showControls: boolean;
	autoplay: boolean;
	muted: boolean;
	noSkin?: boolean;
	loop: boolean;
}

export type TControlsConfig = {
	playButton?: {
		playIcon?: string;
		pauseIcon?: string;
		height?: number;
		width?: number;
	};
	muteButton?: {
		mutedIcon?: string;
		unmutedIcon?: string;
		height?: number;
		width?: number;
	};

}

export enum EProviders {
	THRON = 'Thron',
	VIMEO = 'Vimeo',
	CLOUDFLARE_STREAM = 'Cloudflare_Stream',
}
